import { render, staticRenderFns } from "./SubmitChanges.vue?vue&type=template&id=7e39fbb7&"
import script from "./SubmitChanges.vue?vue&type=script&lang=js&"
export * from "./SubmitChanges.vue?vue&type=script&lang=js&"
import style0 from "./SubmitChanges.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports